import React, { useCallback, useEffect, useRef, useState } from 'react';
import EmailEditor from 'react-email-editor';

const Editor = ({ editorRef, initialDesign, onReady }) => {
  const [ready, setReady] = useState(false);
  const loadedDesignRef = useRef(null);

  const loadInitialDesign = useCallback(() => {
    if (editorRef && editorRef.current && editorRef.current.editor) {
      if (initialDesign && loadedDesignRef.current !== initialDesign) {
        editorRef.current.editor.loadDesign(initialDesign);
        loadedDesignRef.current = initialDesign;
      }
    }
  }, [editorRef, initialDesign]);

  // onReady fires when editor:ready event fires (UI fully rendered).
  const handleReady = () => {
    setReady(true);
    if (onReady) {
      onReady();
    }
  };

  useEffect(() => {
    if (ready) {
      loadInitialDesign();
    }
  }, [ready, loadInitialDesign]);

  return (
    <EmailEditor
      ref={editorRef}
      onReady={handleReady}
      minHeight="calc(100vh - 220px)"
      options={{
        displayMode: 'web',
        features: {
          userUploads: true,
        },
        tools: {
          carousel: {
            enabled: false,
          },
        },
      }}
    />
  );
};

export default Editor;
